import { useState } from "react";
import { toast } from "sonner";
import { BarChart3, ExternalLink, Copy, Check } from "lucide-react";

export default function ReportCard({ publicUrl }) {
  const [copied, setCopied] = useState(false);
  const reportUrl = publicUrl.replace("/p/", "/report/");

  const copyLink = async () => {
    try { await navigator.clipboard.writeText(reportUrl); } catch { /* noop */ }
    setCopied(true);
    toast.success("Report link copied");
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div data-testid="report-card" className="bg-white border border-[#E5E5E2] rounded-sm p-5">
      <h3 className="text-sm font-semibold text-[#0A0A0A] mb-2 flex items-center gap-2"><BarChart3 className="w-4 h-4 text-[#1F3C88]" /> Client Traffic Report</h3>
      <p className="text-sm text-[#575755] leading-relaxed mb-4">A branded, shareable report showing visits, unique visitors, leads and traffic sources. Share it with the agent to forward to their seller.</p>
      <div className="flex gap-2">
        <a data-testid="open-report-link" href={reportUrl} target="_blank" rel="noreferrer" className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-[#0D1B2A] text-white text-sm font-semibold hover:bg-[#152A3E] transition-colors"><ExternalLink className="w-4 h-4" /> Open Report</a>
        <button type="button" data-testid="copy-report-link" onClick={copyLink} className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md border border-[#E5E5E2] text-[#0A0A0A] text-sm font-semibold hover:bg-[#F0EFEC] transition-colors">{copied ? <Check className="w-4 h-4 text-[#1F8A4C]" /> : <Copy className="w-4 h-4" />} Copy link</button>
      </div>
    </div>
  );
}
